<template>
  <!-- 网点管理 -->
  <div class="page-container">
    <div class="page-top-tool">
      <!-- <el-button v-if="userPrower == '1'" type="success" icon="el-icon-plus" size="mini" @click="toAddStorePage">新增名片</el-button> -->
      <div class="right-search">
        <span style="margin-left: 20px;">代理商编号：</span>
        <el-input v-model="proxy_no" clearable placeholder="请输入代理商编号" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <span style="margin-left: 20px;">手机号：</span>
        <el-input v-model="phone" clearable placeholder="请输入代理商手机号" :disabled="loading" size="mini" style="width: 180px;"></el-input>
        <span style="margin-left: 20px;">姓名：</span>
        <el-input v-model="name" clearable placeholder="请输入代理商姓名" :disabled="loading" size="mini" style="width: 180px;"></el-input>
        <el-button type="primary" icon="el-icon-search" size="mini" :disabled="loading" style="margin-left: 20px;" @click="onSearch">搜索</el-button>
      </div>
      <div>
        <el-radio-group v-model="status" size="mini" @input="getData">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="1">正常</el-radio-button>
          <el-radio-button label="2">暂停</el-radio-button>
          <el-radio-button label="3">待审</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      style="width: 100%; font-size: 12px; margin: 20px 0px;"
      :header-cell-style="tableHeaderColor"
    >
    <el-table-column prop="proxy_no" label="代理商编号" width=""></el-table-column>
    <el-table-column prop="name" label="姓名" width="100"></el-table-column>
      <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
       <el-table-column label="等级" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.agent_level == '1'">黄金代理商</span>
          <span v-else-if="scope.row.agent_level == '2'">铂金代理商</span>
          <span v-else-if="scope.row.agent_level == '3'">钻石代理商</span>
        </template>
      </el-table-column>
      <el-table-column label="余额" width="120">
        <template slot-scope="scope">
          ￥ {{ Number(scope.row.account_amount).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                })  }} 元
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="申请时间" width="120">
      </el-table-column>
      <el-table-column prop="start_time" label="审批时间" width="120">
      </el-table-column>
      <el-table-column label="状态" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == '1'" type="success" size="mini">正常</el-tag>
          <el-tag v-if="scope.row.status == '2'" type="danger" size="mini">冻结</el-tag>
          <el-tag v-if="scope.row.status == '3'" type="warning" size="mini">待审批</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="scope">
          <el-button type="text" :disabled="scope.row.status != '1'" size="mini" @click="showTopupDetail(scope.row)">充值</el-button>
          <el-button type="text" size="mini" @click="showStatusDetail(scope.row)">更新状态</el-button>
          <el-button type="text" :disabled="scope.row.status != '1'" size="mini" @click="showPayDetail(scope.row)">充值记录</el-button>
          <el-button type="text" :disabled="scope.row.status != '1'" size="mini" @click="showSaleDetail(scope.row)">销售记录</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
    :current-page.sync="currentPage"
    :page-size="pageSize"
    hide-on-single-page
    background
    layout="total, prev, pager, next"
    :total="total"
    @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 充值 -->
    <el-dialog title="充值" :visible.sync="topupDialogVisible" @close="closeTopupDetail" width="30%" :show-close="true" :close-on-click-modal="false">
      <div class="active-detail" style="padding: 20px 10px;">
        <div class="dialog-item">代理商：{{ activeObj.name }} ({{ activeObj.phone }})</div>
        <div class="dialog-item">
          账号状态：
          <el-tag v-if="activeObj.status == '1'" type="success" size="mini">正常</el-tag>
          <el-tag v-else-if="activeObj.status == '2'" type="danger" size="mini">暂停</el-tag>
          <el-tag v-else-if="activeObj.status == '3'" type="warning" size="mini">待审批</el-tag>
        </div>
        <div class="dialog-item">
          充值金额：
          <el-input placeholder="请输入金额" v-model="money" size="small" clearable style="width: 140px;margin-right: 5px;" /> 元
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeTopupDetail">取 消</el-button>
        <el-button type="primary" @click="onTopupConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 更新状态 -->
    <el-dialog title="更新状态" :visible.sync="statusDialogVisible" @close="closeStatusDetail" width="50%" :show-close="true" :close-on-click-modal="false">
      <div class="active-detail" style="padding: 20px 10px;">
        <div class="dialog-item">代理商：{{ activeObj.name }} ({{ activeObj.phone }})</div>
        <div class="dialog-item" style="margin: 10px 0px;">
          代理等级：
          <el-radio-group v-model="agent_level" size="small">
            <el-radio-button label="1">黄金代理商（首充1w）</el-radio-button>
            <el-radio-button label="2">铂金代理商（首充3w）</el-radio-button>
            <el-radio-button label="3">钻石代理商（首充5w）</el-radio-button>
          </el-radio-group>
        </div>
        <div class="dialog-item">
          账号状态：
          <el-radio-group v-model="activeStatus" size="small">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">冻结账号</el-radio-button>
            <el-radio-button label="3">待审批</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeStatusDetail">取 消</el-button>
        <el-button type="primary" @click="onStatusConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 销售记录 -->
    <el-dialog title="销售记录" :visible.sync="saleDialogVisible" @close="closeSaleDetail" :show-close="true" width="80%" style="margin-top: -30px;">
      <div class="active-detail">
        <div class="sale-search-view">
          <span style="margin-left: 20px;">客户姓名：</span>
          <el-input v-model="customer_name" clearable placeholder="请输入客户姓名" :disabled="loading" size="mini" style="width: 180px;"></el-input>
          <span style="margin-left: 20px;">手机号：</span>
          <el-input v-model="customer_phone" clearable placeholder="请输入客户手机号" :disabled="loading" size="mini" style="width: 180px;"></el-input>
          <el-button type="primary" icon="el-icon-search" size="mini" :disabled="loading" style="margin-left: 20px;" @click="querySalesData">搜索</el-button>
        </div>
        <el-table
          :data="saleList"
          style="width: 100%">
          <el-table-column prop="agent_name" label="代理商"  width="180"></el-table-column>
          <el-table-column label="销售名片"  width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.product_type == '1'">个人版</span>
              <span v-else-if="scope.row.product_type == '2'">团队版</span>
              <span v-else-if="scope.row.product_type == '4'">企业版</span>
              <span v-else-if="scope.row.product_type == '8'">矩阵名片（月会员）</span>
              <span v-else-if="scope.row.product_type == '9'">矩阵名片（永久版）</span>
            </template>
          </el-table-column>
          <el-table-column prop="sale_price" label="销售成本"  width="180"></el-table-column>
          <el-table-column prop="customer_name" label="客户姓名"  width="180"></el-table-column>
          <el-table-column prop="customer_phone" label="客户电话"  width="180"></el-table-column>
          <el-table-column prop="create_time" label="开通时间"  width="180"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
        :current-page.sync="saleCurrentPage"
        :page-size="salePageSize"
        hide-on-single-page
        background
        layout="total, prev, pager, next"
        :total="saleTotal"
        style="margin-top: 20px;"
        @current-change="handleSaleCurrentChange">
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 充值记录 -->
    <el-dialog title="充值记录" :visible.sync="payDialogVisible" @close="closePayDetail" :show-close="true" width="60%" style="margin-top: -30px;">
      <div class="active-detail">
        <div>代理商：{{ activeObj.name }} ({{ activeObj.phone }})</div>
        <el-table
          :data="payList"
          style="width: 100%">
          <el-table-column prop="pay_time" label="充值时间"  width="180"></el-table-column>
          <el-table-column prop="money" label="充值金额"  width="180"></el-table-column>
          <el-table-column prop="account_amount" label="账户余额"  width="180"></el-table-column>
          <el-table-column prop="type" label="类型"  width="180"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'StorePage',

  data() {
    return {
      userPrower: '', // 用户权限
      name: '', // 姓名
      company_name: '', // 公司名称
      user_no: '', // 用户编号
      proxy_no: '', // 代理商编号
      phone: '', // 手机号
      customer_name: '',// 客户姓名
      customer_phone: '',// 客户手机号
      status: '',
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      activeObj: {},
      topupDialogVisible: false,
      baseurl: '',
      agent_level: '1',

      money: '',
      activeStatus: '',
      statusDialogVisible: false,

      saleDialogVisible: false,
      saleList: [],
      saleCurrentPage: 1,
      salePageSize: 8,
      saleTotal: 0,

      payDialogVisible: false,
      payList: []
    };
  },

  mounted() {
    this.baseurl = this.$baseUrl
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      this.userPrower = userInfo.prower
    } else {
      this.$http({
        method: 'post',
        url: 'user_exit'
      })
      this.$router.push({
        path: '/login'
      })
    }
    this.getData()
  },

  methods: {
    getData() {
      this.loading = true
      this.$http({
        method: 'post',
        url: `/agentuser/find?page=${this.currentPage}&pageSize=${this.pageSize}`,
        params: {
          proxy_no: this.proxy_no,
          phone: this.phone,
          name: this.name,
          status: this.status
        }
      })
      .then(res => {
        this.loading = false
        if (res.errno == 0) {
          const { data, page, pageSize, count } = res.data
          this.tableData = data
          this.currentPage = page
          this.pageSize = pageSize
          this.total = count
        } else {
          this.$message.error('查询失败')
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('服务端异常，查询失败')
        console.error('查询异常：', err.message);
      })
    },
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      return 'background-color: #F2F2F2;color:#101010;'
    },
    onSearch() {
      this.currentPage = 1
      this.getData()
    },
    toAddStorePage() {
      this.$router.push({
        path: '/addPersonal'
      })
    },
    // 页码改变
    handleCurrentChange(page) {
      this.currentPage = page
      this.getData()
    },
    // 充值弹框
    showTopupDetail(row) {
      this.activeObj = row
      this.money = ''
      this.topupDialogVisible = true
    },
    // 关闭充值弹框
    closeTopupDetail() {
      this.activeObj = {}
      this.money = ''
      this.topupDialogVisible = false
    },
    // 确认充值
    onTopupConfirm() {
      if (!this.money || this.money.trim() == '') {
        this.$message.warning('请填写充值金额')
        return
      }
      if (!parseFloat(this.money)) {
        this.$message.warning('请填写正确的金额')
        return
      } else if ( parseFloat(this.money) < 100) {
        this.$message.warning('最少充值金额100元')
        return
      }
      if (this.activeObj.status != '1') {
        this.$message.warning('非正常状态代理商不能充值')
        return
      }

      this.$confirm(`确定要给 ${this.activeObj.name} 充值 ${this.money} 元吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          
          this.loading = true
          this.$http({
            method: 'post',
            url: `/agentuser/topup`,
            params: {
              proxy_no: this.activeObj.proxy_no,
              money: parseFloat(this.money)
            }
          })
          .then(res => {
            this.loading = false
            if (res.errno == 0) {
              this.$message.success('充值成功')
              this.onPushPayLogs()
            } else {
              this.$message.error('充值失败')
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('服务端异常，充值失败')
            console.error('查询异常：', err.message);
          })

        }).catch(() => {})
      
    },
    getCurrentTime() {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 增加充值记录
    onPushPayLogs() {
      let pay_logs = this.activeObj.pay_logs
      if (!pay_logs || pay_logs == '' || pay_logs == '[]') {
          pay_logs = []
      } else {
          pay_logs = JSON.parse(pay_logs)
      }
      pay_logs.unshift({
          pay_time: this.getCurrentTime(),
          money: parseFloat(this.money),
          account_amount: parseFloat(this.activeObj.account_amount) + parseFloat(this.money),
          type: '客服充值'
      })
      this.$http({
        method: 'post',
        url: `/agentuser/update`,
        params: {
          id: this.activeObj.id,
          pay_logs: JSON.stringify(pay_logs)
        }
      })
      .then(res => {
        if (res.errno == 0) {
          this.$message.success('充值记录增加成功')
          this.closeTopupDetail()
          this.getData()
        } else {
          this.$message.error('充值记录增加失败')
        }
      })
      .catch(err => {
        this.$message.error('服务端异常，充值记录增加失败')
        console.error('查询异常：', err.message);
      })
    },
    // 更新状态弹框
    showStatusDetail(row) {
      this.activeObj = row
      this.activeStatus = row.status
      this.statusDialogVisible = true
    },
    // 关闭更新状态弹框
    closeStatusDetail() {
      this.activeObj = {}
      this.activeStatus = ''
      this.statusDialogVisible = false
    },
    // 确认更新状态
    onStatusConfirm() {
      this.$confirm(`确定要更新 ${this.activeObj.name} 状态吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          
          this.loading = true
          this.$http({
            method: 'post',
            url: `/agentuser/update`,
            params: {
              id: this.activeObj.id,
              agent_level: this.agent_level,
              status: this.activeStatus
            }
          })
          .then(res => {
            this.loading = false
            if (res.errno == 0) {
              this.$message.success('操作成功')
              this.closeStatusDetail()
              this.getData()
            } else {
              this.$message.error('操作失败')
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('服务端异常，充值失败')
            console.error('查询异常：', err.message);
          })

        }).catch(() => {})
    },
    // 销售记录弹框
    showSaleDetail(row) {
      this.activeObj = row
      this.saleList = []
      this.saleDialogVisible = true
      this.querySalesData()
    },
    // 关闭销售记录弹框
    closeSaleDetail() {
      this.activeObj = {}
      this.saleList = []
      this.customer_name = ''
      this.customer_phone = ''
      this.saleDialogVisible = false
    },
    // 查询销售记录
    querySalesData() {
      this.$http({
            method: 'post',
            url: `/agentsales/find?page=${this.saleCurrentPage}&pageSize=${this.salePageSize}`,
            params: {
              agent_no: this.activeObj.proxy_no,
              customer_name: this.customer_name,
              customer_phone: this.customer_phone
            }
          })
          .then(res => {
            this.loading = false
            if (res.errno == 0) {
              const { data, page, pageSize, count } = res.data
              this.saleList = data
              this.saleCurrentPage = page
              this.salePageSize = pageSize
              this.saleTotal = count
            }
          })
          .catch(err => {
            this.$message.error('服务端异常，充值失败')
            console.error('查询异常：', err.message);
          })
    },
    handleSaleCurrentChange(page) {
      this.saleCurrentPage = page
      this.querySalesData()
    },
    // 充值记录弹框
    showPayDetail(row) {
      this.activeObj = row
      this.payList = []
      if (this.activeObj.pay_logs && this.activeObj.pay_logs != '' && this.activeObj.pay_logs != '[]') {
        this.payList = JSON.parse(this.activeObj.pay_logs)
      }
      this.payDialogVisible = true
    },
    // 关闭销售记录弹框
    closePayDetail() {
      this.activeObj = {}
      this.payList = []
      this.payDialogVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 25px;
  overflow-y: scroll;

  .page-top-tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
	width: 4px;
}
.page-container::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.active-detail {
  position: relative;
  .shenpi-resuilt-img {
    position: absolute;
    width: 120px;
    top: -70px;
    right: 0px;
    opacity: 0.6;
  }

  .active-images-layout {
    display: flex;
    flex-wrap: wrap;
    .active-images-item {
      margin: 20px;
      cursor: pointer;
    }
  }
}

.dialog-item {
  margin-bottom: 15px;
}

.active-detail-dialog {
  height: 480px;
  overflow-y: scroll;
}
.active-detail-dialog-bottom {
  margin-top: 20px;
  text-align: right;
}

/* 修改滚动条样式 */
.active-detail-dialog::-webkit-scrollbar {
	width: 4px;
}
.active-detail-dialog::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.copy-link {
  margin-left: 10px;
  color: #409EFF;
}
.copy-link:hover {
  cursor: pointer;
}
.url-style {
  text-decoration: none;
  color: #409EFF;
}
.sale-search-view {
  margin-bottom: 15px;
}
</style>